const colors = {
  white: '#FFF',
  black: '#000',
  formBackground: '#CADCEB',
  primary: '#28A0DC',
  secondary: '#105B7F',
  brandingPrimary: '#003B71',
  brandingAccent: '#FFD100',
  lightGray: '#9E9E9E',
  lighterGray: '#E6ECEF',
  lightestGray: '#E8E8E8',
  blueGray: '#32446b',
  whiteGray: '#F4F4F4',
  gray: '#4D4D4D',
  darkGray: '#353535',
  red: '#DB3737',
  darkRed: '#A82A2A',
  muted: '#5C7080',
  green: '#41B751',
  darkGreen: '#26692F',
  lightestGreen: '#E8F4E7',

  icons: {
    azure: '#4289C9', ///// clock icon
    amber: '#FAB03C', ///// the (!) icon
    citrus: '#B9D67C', //// checkmark icon
    slate: '#758196', ///// calendar icon
  },
};

export default colors;
